'use strict';
import { Grammar } from "./Grammar";
import { TokenType } from "./Types";
import { ValidateCaption } from "./validation/validateCaption";
export class Tokenizer {
    constructor(text) {
        this.tokens = [];
        this.ast = {
            type: "Root",
            token: null,
            raw: "",
            children: []
        };
        this.text = text;
        this.tokens = [];
        this.putRootChildren();
        this.ast.children.forEach(node => this.putInlineChildren(node));
    }
    getAST() {
        return this.ast;
    }
    putRootChildren() {
        while (this.text.length > 0) {
            let match = null;
            if (this.text.length === 0)
                break;
            const whitespace = this.text.match(/^\s+/);
            let hadBlankLine = false;
            if (whitespace) {
                hadBlankLine = /\n/.test(whitespace[0]);
                this.text = this.text.slice(whitespace[0].length);
                if (this.text.length === 0)
                    break;
            }
            if (this.text.match(Grammar.BLOCKS.CAPTION_PARAMETER) !== null) {
                match = this.text.match(Grammar.BLOCKS.CAPTION_PARAMETER);
                if (match != null) {
                    const fullBlock = match[0];
                    const dateMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_DATE);
                    const titleMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_TITLE);
                    const templateMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_TEMPLATE);
                    const thumbnailMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_THUMBNAIL);
                    const slugMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_SLUG);
                    const tagsMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_TAGS);
                    const clusterMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_CLUSTER);
                    const orderMatch = fullBlock.match(Grammar.BLOCKS.CAPTION_FIND_ORDER);
                    let captionToken = {};
                    captionToken.date = dateMatch ? dateMatch[1].trim() : "";
                    captionToken.title = titleMatch ? titleMatch[1].trim() : "";
                    captionToken.template = templateMatch ? templateMatch[1].trim() : "";
                    captionToken.thumbnail = thumbnailMatch ? thumbnailMatch[1].trim() : "";
                    captionToken.slug = slugMatch ? slugMatch[1].trim() : "";
                    captionToken.tags = tagsMatch ? tagsMatch[1].trim() : "";
                    captionToken.cluster = clusterMatch ? clusterMatch[1].trim() : "";
                    captionToken.order = orderMatch ? orderMatch[1].trim() : "";
                    captionToken = ValidateCaption.validate(captionToken);
                    this.text = this.text.replace(Grammar.BLOCKS.CAPTION, "");
                    this.ast.children.push({
                        type: TokenType.CAPTION,
                        token: captionToken,
                        raw: "",
                        children: []
                    });
                }
                else {
                    this.text = this.text.replace(Grammar.BLOCKS.CAPTION, "");
                    let unmarkableToken = {};
                    unmarkableToken.type = TokenType.UNMARKABLE;
                    unmarkableToken.value = "\n\\* \n Error: Incorrectly formatted Caption block. Please check the format. \n\\* \n";
                    this.ast.children.push({
                        type: TokenType.UNMARKABLE,
                        token: unmarkableToken,
                        raw: unmarkableToken.value,
                        children: []
                    });
                    continue;
                }
            }
            match = this.text.match(Grammar.BLOCKS.UNMARKABLE_BLOCK);
            if (match) {
                const unmarkableToken = {};
                unmarkableToken.type = TokenType.UNMARKABLE;
                unmarkableToken.value = match[1];
                this.ast.children.push({
                    type: TokenType.UNMARKABLE,
                    token: unmarkableToken,
                    raw: match[0],
                    children: []
                });
                this.text = this.text.slice(match[0].length);
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.CODE_IN_CODE);
            if (match) {
                const languageMatchResult = match[2];
                const bodyMatchResult = match[3];
                if (languageMatchResult && bodyMatchResult) {
                    const language = languageMatchResult;
                    const body = bodyMatchResult ?? '';
                    const codeToken = {};
                    codeToken.type = TokenType.CODE_IN_CODE;
                    codeToken.code = body;
                    codeToken.language = language;
                    this.ast.children.push({
                        type: TokenType.CODE_IN_CODE,
                        token: codeToken,
                        raw: body,
                        children: [],
                    });
                    this.text = this.text.slice(match[0].length);
                }
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.FORMULA_BLOCK);
            if (match) {
                const inner = match[0].slice(2, match[0].length - 2).trim();
                const token = {};
                token.type = TokenType.FORMULA_BLOCK;
                token.formula = inner;
                this.ast.children.push({
                    type: TokenType.FORMULA_BLOCK,
                    token: token,
                    raw: match[0],
                    children: []
                });
                this.text = this.text.slice(match[0].length);
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.CODE_BLOCK);
            if (match) {
                const languageMatchResult = match[0].match(Grammar.BLOCKS.CODE_BLOCK_LANG);
                const bodyMatchResult = match[0].match(Grammar.BLOCKS.CODE_BLOCK_BODY);
                if (bodyMatchResult) {
                    const language = languageMatchResult ? languageMatchResult[0].trim() : '';
                    const body = bodyMatchResult[0];
                    const codeToken = {};
                    codeToken.type = TokenType.CODE_BLOCK;
                    codeToken.code = body;
                    codeToken.language = language;
                    let node = {
                        type: TokenType.CODE_BLOCK,
                        token: codeToken,
                        raw: body,
                        children: []
                    };
                    this.ast.children.push(node);
                    this.text = this.text.slice(match[0].length);
                }
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.HEADING);
            if (match) {
                const levelMatchResult = match[0].match(Grammar.BLOCKS.HEADING_LEVEL);
                if (levelMatchResult) {
                    const level = levelMatchResult[0];
                    if (!level || level.length > match[0].length) {
                        return;
                    }
                    const body = match[0].slice(level.length + 1, match[0].length);
                    const types = [
                        TokenType.HEADING_FIRST,
                        TokenType.HEADING_SECOND,
                        TokenType.HEADING_THIRD,
                        TokenType.HEADING_FOURTH,
                        TokenType.HEADING_FIFTH
                    ];
                    const contentOnly = match[0].replace(/^#{1,6}\s+/, '').replace(/\n$/, '');
                    if (!level || level.length > types.length) {
                        return;
                    }
                    const itype = level.length - 1;
                    const headToken = {};
                    headToken.type = types[itype];
                    headToken.value = contentOnly;
                    this.ast.children.push({
                        type: headToken.type,
                        token: headToken,
                        raw: contentOnly,
                        children: []
                    });
                    this.text = this.text.slice(match[0].length);
                }
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.IMAGE);
            if (match) {
                const altMatchResult = match[0].match(Grammar.BLOCKS.IMAGE_NAME);
                const urlMatchResult = match[0].match(Grammar.BLOCKS.IMAGE_URL);
                if (altMatchResult && urlMatchResult && altMatchResult[0] && urlMatchResult[0]) {
                    const alt = altMatchResult[0].substring(2, altMatchResult[0].length - 1);
                    const url = urlMatchResult[0].substring(1, urlMatchResult[0].length - 1);
                    const imageToken = {};
                    imageToken.type = TokenType.IMAGE;
                    imageToken.alt = alt;
                    imageToken.url = url;
                    this.ast.children.push({
                        type: TokenType.IMAGE,
                        token: imageToken,
                        raw: match[0],
                        children: []
                    });
                    this.text = this.text.slice(match[0].length);
                }
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.LIST);
            if (match) {
                const rawBlock = match[0];
                const cleanBlock = rawBlock.replace(/^\s*\\\*\s*|\s*\\\*\s*$/g, '');
                const lines = cleanBlock.split('\n').filter(l => l.trim() !== '');
                const firstLine = lines[0];
                const hasTitle = !firstLine.trim().match(/^\s*(-|\[\]|\[x\])/);
                const title = hasTitle ? firstLine.trim().replace(/:$/, '') : undefined;
                const itemLines = hasTitle ? lines.slice(1) : lines;
                const listNode = {
                    type: TokenType.LIST,
                    token: {
                        type: TokenType.LIST,
                        title: title,
                        value: cleanBlock
                    },
                    raw: cleanBlock,
                    children: []
                };
                itemLines.forEach(line => {
                    const trimmed = line.trim();
                    const rawValue = trimmed.replace(/^\s*(-|\[\s?\]|\[x\])\s*/, '').trim();
                    if (trimmed.length > 0) {
                        listNode.children.push({
                            type: TokenType.LIST_ITEM,
                            token: {
                                type: TokenType.LIST_ITEM,
                                value: trimmed
                            },
                            raw: rawValue,
                            children: []
                        });
                    }
                });
                this.ast.children.push(listNode);
                listNode.children.forEach(itemNode => {
                    this.putInlineChildren(itemNode);
                });
                this.text = this.text.slice(match[0].length);
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.QUOTE);
            if (match) {
                const quoteToken = {};
                quoteToken.type = TokenType.QUOTE;
                const cleanContent = match[0].replace(/^>\s?/gm, "\n");
                quoteToken.value = cleanContent;
                this.ast.children.push({
                    type: TokenType.QUOTE,
                    token: quoteToken,
                    raw: cleanContent,
                    children: []
                });
                this.text = this.text.slice(match[0].length);
                continue;
            }
            match = this.text.match(Grammar.BLOCKS.TABLE);
            if (match) {
                const tableBlock = match[0].trim();
                const rows = tableBlock.split('\n');
                const rawHeader = rows[0];
                const rawSeparator = rows[1];
                const rawBody = rows.slice(2);
                const headRowToken = {};
                headRowToken.type = TokenType.TABLE_HEAD_ROW;
                headRowToken.value = rawHeader;
                headRowToken.row = rawHeader;
                const headCell = rawHeader.split('|').map(cell => cell.trim()).filter(cell => cell.length > 0);
                const headCellArray = [];
                headCell.forEach(cell => {
                    const cellToken = {};
                    cellToken.type = TokenType.UNKNOWN_TEXT;
                    cellToken.value = cell;
                    headCellArray.push({
                        type: TokenType.UNKNOWN_TEXT,
                        token: cellToken,
                        raw: cell,
                        children: []
                    });
                });
                const headRowAST = {
                    type: TokenType.TABLE_HEAD_ROW,
                    token: headRowToken,
                    raw: "",
                    children: [...headCellArray]
                };
                const bodyArray = [];
                rawBody.forEach((bodyRow) => {
                    const bodyRowToken = {};
                    bodyRowToken.type = TokenType.TABLE_BODY_ROW;
                    bodyRowToken.value = bodyRow;
                    bodyRowToken.row = bodyRow;
                    bodyRowToken.children = [];
                    const bodyCellArray = [];
                    bodyRow.split('|').map(cell => cell.trim()).filter(cell => cell.length > 0).forEach(cell => {
                        const cellToken = {};
                        cellToken.type = TokenType.UNKNOWN_TEXT;
                        cellToken.value = cell;
                        bodyCellArray.push({
                            type: TokenType.UNKNOWN_TEXT,
                            token: cellToken,
                            raw: cell,
                            children: []
                        });
                    });
                    const bodyRowAST = {
                        type: TokenType.TABLE_BODY_ROW,
                        token: bodyRowToken,
                        raw: "",
                        children: [...bodyCellArray]
                    };
                    bodyArray.push(bodyRowAST);
                });
                this.ast.children.push({
                    type: TokenType.TABLE,
                    token: {
                        type: TokenType.TABLE,
                        value: tableBlock,
                        row: "",
                        children: []
                    },
                    raw: "",
                    children: [headRowAST, ...bodyArray]
                });
                this.text = this.text.slice(match[0].length);
                continue;
            }
            const nextNewline = this.text.indexOf('\n');
            const end = nextNewline === -1 ? this.text.length : nextNewline + 1;
            const chunk = this.text.slice(0, end);
            this.ast.children.push({
                type: TokenType.PARAGRAPH,
                raw: chunk,
                token: {
                    type: TokenType.PARAGRAPH,
                    value: chunk
                },
                children: []
            });
            this.text = this.text.slice(end);
        }
    }
    putInlineChildren(node) {
        if (node.type === TokenType.QUOTE
            || node.type === TokenType.LIST_ITEM
            || node.type === TokenType.UNKNOWN_TEXT
            || node.type === TokenType.PARAGRAPH
            || node.type === TokenType.HEADING_FIRST
            || node.type === TokenType.HEADING_SECOND
            || node.type === TokenType.HEADING_THIRD
            || node.type === TokenType.HEADING_FOURTH
            || node.type === TokenType.HEADING_FIFTH) {
            while (node.raw.length > 0) {
                let match = null;
                if (node.raw.length === 0)
                    break;
                const whitespace = node.raw.match(/^\s+/);
                if (whitespace) {
                    if (node.raw.length === 0)
                        break;
                }
                match = node.raw.match(Grammar.BLOCKS.STRONG_TEXT);
                if (match) {
                    const strongToken = {};
                    strongToken.type = TokenType.STRONG;
                    strongToken.value = match[1];
                    node.children.push({
                        type: TokenType.STRONG,
                        token: strongToken,
                        raw: match[1],
                        children: []
                    });
                    node.raw = node.raw.slice(match[0].length);
                    continue;
                }
                match = node.raw.match(Grammar.BLOCKS.LINK);
                if (match) {
                    const fullMatch = match[0];
                    const linkName = match[1];
                    const linkUrl = match[2];
                    const linkToken = {
                        type: TokenType.LINK,
                        name: linkName,
                        url: linkUrl
                    };
                    node.children.push({
                        type: TokenType.LINK,
                        token: linkToken,
                        raw: fullMatch,
                        children: []
                    });
                    node.raw = node.raw.slice(fullMatch.length);
                    continue;
                }
                match = node.raw.match(Grammar.BLOCKS.INLINE_CODE_BLOCK);
                if (match) {
                    const inlineCodeToken = {};
                    inlineCodeToken.type = TokenType.CODE_INLINE;
                    inlineCodeToken.value = match[1];
                    node.children.push({
                        type: TokenType.CODE_INLINE,
                        token: inlineCodeToken,
                        raw: match[0],
                        children: []
                    });
                    node.raw = node.raw.slice(match[0].length);
                    continue;
                }
                match = node.raw.match(Grammar.BLOCKS.FORMULA_INLINE);
                if (match) {
                    const inner = match[0].slice(1, match[0].length - 1).trim();
                    const token = {};
                    token.type = TokenType.FORMULA_INLINE;
                    token.formula = inner;
                    node.children.push({
                        type: TokenType.FORMULA_INLINE,
                        token: token,
                        raw: match[0],
                        children: []
                    });
                    node.raw = node.raw.slice(match[0].length);
                    continue;
                }
                match = node.raw.match(Grammar.BLOCKS.UNDER_LINE);
                if (match) {
                    const body = match[0].substring(1, match[0].length - 1);
                    const token = {};
                    token.type = TokenType.UNDER_LINE;
                    token.value = body;
                    node.children.push({
                        type: TokenType.UNDER_LINE,
                        token: token,
                        raw: body,
                        children: []
                    });
                    node.raw = node.raw.slice(match[0].length);
                    continue;
                }
                match = node.raw.match(Grammar.BLOCKS.BADGE);
                if (match) {
                    const body = match[1];
                    const colorName = match[2];
                    const badgeToken = {};
                    badgeToken.type = TokenType.BADGE;
                    badgeToken.value = body;
                    badgeToken.color = colorName;
                    node.children.push({
                        type: TokenType.BADGE,
                        token: badgeToken,
                        raw: match[0],
                        children: []
                    });
                    node.raw = node.raw.slice(match[0].length);
                    continue;
                }
                match = node.raw.match(Grammar.BLOCKS.COLOR);
                if (match) {
                    const body = match[1];
                    const colorName = match[2];
                    const colorToken = {};
                    colorToken.type = TokenType.COLOR;
                    colorToken.value = body;
                    colorToken.color = colorName;
                    node.children.push({
                        type: TokenType.COLOR,
                        token: colorToken,
                        raw: match[0],
                        children: []
                    });
                    node.raw = node.raw.slice(match[0].length);
                    continue;
                }
                const specialChars = /[*[$_`#</]/;
                const nextSpecial = node.raw.search(specialChars);
                let end;
                if (nextSpecial === 0) {
                    end = 1;
                }
                else if (nextSpecial === -1) {
                    end = node.raw.length;
                }
                else {
                    end = nextSpecial;
                }
                const chunk = node.raw.slice(0, end);
                const lastNode = node.children[node.children.length - 1];
                if (lastNode && lastNode.type === TokenType.TEXT) {
                    lastNode.raw += chunk;
                    if (lastNode.token)
                        lastNode.token.value += chunk;
                }
                else {
                    node.children.push({
                        type: TokenType.TEXT,
                        raw: chunk,
                        token: { type: TokenType.TEXT, value: chunk },
                        children: []
                    });
                }
                node.raw = node.raw.slice(end);
            }
        }
        if (node.children && node.children.length > 0) {
            node.children.forEach(child => this.putInlineChildren(child));
        }
    }
}
